export default __webpack_public_path__ + "static/media/img-npay-badge.c9171bff.png";